import React from 'react';
import ItemInventoryHistory from './ItemInventoryHistory';

interface ItemIssueHistoryTabProps {
  itemId?: string;
  companyId?: string;
  active: boolean;
}

export default function ItemIssueHistoryTab({ itemId, companyId, active }: ItemIssueHistoryTabProps) {
  return <ItemInventoryHistory itemId={itemId} companyId={companyId} direction='issue' active={active} />;
}
